import type { IconProps } from '../types/IconProps.ts';
export const Euro: IconProps = {
    name: 'Euro',
    children: [
        `<path d="M19 5.07a8 8 0 1 0 0 13.86M4 9h11M4 14h8" />`,
    ]
};